import styled from 'styled-components';

export const PopupTopSection = styled.div`
  display: flex;
  align-items: center;
  padding: 6px;
`;
export const ClosePopupImage = styled.img`
transform: rotate(45deg);
width: 35px;
@media (min-width: 720px){
    cursor:pointer;
}
}
`;
export const PopupText = styled.div`
font-size: 18px;
font-weight: 600;
padding: 0px 6px;
opacity: 0.9;
}
`;
